import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Box, Text, Spinner } from '@chakra-ui/react';
import useServerApi from 'hooks/useServerApi';
import Details from './Details';

const ViewRecording = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    const [{ get }] = useServerApi();
    const [callData, setCallData] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    useEffect(() => {
        if (!id) {
            navigate('/page-not-found');
            return;
        }
        if (id && !isNaN(id)) {
            fetchCallDetails();
        }
    }, [id, navigate]);

    const fetchCallDetails = async () => {
        setLoading(true);
        setError(null);
        try {
            const [success, result] = await get(`/rest_endpoints/public_call_history/details/${id}`);
            if (success) {
                setCallData(result);
            } else {
                throw new Error('Failed to fetch call details');
            }
        } catch (err) {
            console.error('Error fetching call details:', err);
            setError(err.message);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className='min-h-screen bg-gradient-to-br from-indigo-500 to-purple-600 flex items-center justify-center p-4'>
            <div className='w-full max-w-4xl space-y-8 bg-white p-6 rounded-xl shadow-2xl'>
                {loading && (
                    <Box textAlign="center" py={10}>
                        <Spinner size="xl" />
                        <Text mt={4}>Loading call details...</Text>
                    </Box>
                )}
                {error && (
                    <Box textAlign="center" py={10}>
                        <Text color="red.500">Error: {error}</Text>
                    </Box>
                )}
                {callData && <Details callData={callData} />}
            </div>
        </div>
    );
};

export default ViewRecording;